import axiosInstance, { microServices } from 'network/apis/index'
import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'

export const getGeneralReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/pnl-report/general', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}
